import type { UserType } from 'src/auth/types';

import * as Sentry from '@sentry/react';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export function initSentry() {
  if (!CONFIG.sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: CONFIG.sentry.dsn,
    environment: import.meta.env.MODE,
    release: `${CONFIG.appName}@${CONFIG.appVersion}`,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: !import.meta.env.DEV,
  });
}

export function setSentryUser(user: UserType, assumedRoleId: number | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: String(user.id),
    data: {
      ...(assumedRoleId != null && { adminRoleId: String(assumedRoleId) }),
    },
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
